export default __webpack_public_path__ + "static/media/free-shipping.5a006b00.gif";